export default __webpack_public_path__ + "static/media/4745@3x.6019c84e.webp";